module.exports = __webpack_public_path__ + "img/5.1ec43e6c.jpg";